
import { defineComponent } from "vue"
import { spatialOmicsApi } from '@/request/index'
import { useRouter } from 'vue-router'
import { useStore } from "vuex";
import { ArrowDown } from '@element-plus/icons-vue'
import { BiotechCategory } from "@/types/Request";


export default defineComponent({
  data() {
    return {
      biotechCategories: [],
      selectedBiotechCategory: '',
      router: useRouter(),
      store: useStore()
    }
  },
  components: {
    ArrowDown,
  },
  computed: {
    /**
     * 控制面包屑组件中biotech项是否显示
     */
    biotechVisible () {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return this.store.state.biotechVisible
    },

    /**
     * 控制面包屑组件中dataset项是否显示
     */
    datasetVisible () {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return this.store.state.datasetVisible
    },

    /**
     * 获取当前的biotech名称
     */
    selectedBiotech () {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return this.store.state.selectedBiotechName
    },

    /**
     * 获取当前的dataset名称
     */
    selectedDataset () {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return this.store.state.selectedDatasetName
    }
  },
  methods: {
    /**
     * 做初始化操作，获取数据库中所有biotech的类别，更新其下拉列表，并选择第一项
     */
    init () {
      spatialOmicsApi.getAllBiotechType().then((res) => {
        let order = ["Spatial Transcriptomics", "Spatial Proteomics", "Spatial Metabolomics", "Spatial Genomics", "Spatial MultiOmics", "Other"]
        let i=0
        while(i<res.data.length){
          let idx = order.indexOf(res.data[i].biotech_type)
          if(idx > 0 && idx !== i){
            console.log(i, idx)
            let tmp = res.data[idx]
            res.data[idx] = res.data[i]
            res.data[i] = tmp
            continue
          }
          i++
        }
        this.biotechCategories = res.data
        this.selectBiotechCategory(this.biotechCategories[0])
      })
    },

    /**
     * 设置当前biotech类别，并更新BiotechListView组件
     * @param item biotech类别
     */
    selectBiotechCategory (item: BiotechCategory) {
      this.selectedBiotechCategory = item.biotech_type
      this.router.push({
        name: 'biotechList',
        query: {
          biotechType: this.selectedBiotechCategory
        }
      })
      // const $store = useStore()
      this.store.commit('setBiotechCategory', this.selectedBiotechCategory)
      // this.store.commit('switchBiotechCategory')
      this.store.commit('setDatasetVisible', false)
      this.store.commit('setBiotechVisible', false)
    },

    /**
     * 点击面包屑biotech类别的回调函数，将biotech和dataset隐去
     */
    clickBiotechCategoryCallback () {
      console.log('clickBiotechCategoryCallback', this.store.state.selectedBiotechCategory)
      this.store.commit('setDatasetVisible', false)
      this.store.commit('setBiotechVisible', false)
    },

    /**
     * 点击面包屑biotech的回调函数，将dataset隐去
     */
    clickBiotechCallback () {
      console.log('clickBiotechCallback', this.store.state.datasetVisible)
      this.store.commit('setDatasetVisible', false)
      console.log('clickBiotechCallback', this.store.state.datasetVisible)
    },

    /**
     * TODO:完整返回
     */ 
    getDatasetInfo (datasetID: number) {
      console.log('getDatasetInfo', datasetID)
      spatialOmicsApi.getDatasetByDatasetID(datasetID).then(async (res) => {
        console.log('getDatasetInfo res', res)
        let dataID = res.data.data[0]['id']
        spatialOmicsApi.getDataByDataID(dataID).then(async (res) => {
                console.log('getDataByDataID res', res)
                this.selectedBiotechCategory = res.data['biotech_category']
              })
      })
    },

  },
  mounted() {
    console.log('query: ', this.$route.query)
    // eslint-disable-next-line no-prototype-builtins
    if (this.$route.query.hasOwnProperty('datasetID')) {
      spatialOmicsApi.getAllBiotechType().then((res) => {
        console.log("browseview init getAllBiotechType", typeof(this.$route.query['datasetID']),  this.$route)
        this.biotechCategories = res.data
      })
      this.getDatasetInfo(Number(this.$route.query['datasetID']))
    }
    else{
      this.init()
    }
  }
})

